import AnalyticsAdminItemPagingResultModelBase from '../_generated/modelBases/analytics-admin-item-paging-result-model-base';

export default class AnalyticsAdminItemPagingResultModel extends AnalyticsAdminItemPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
